import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockGr = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "53px",
	height: "53px",
	viewBox: "0 0 53 53",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "09EB65DE-074C-4967-B4B9-38ADA04CB18D"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "UI",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Registruokit\\u0117s-tyrimui---N\\u0117ra-laik\\u0173",
			transform: "translate(-836.000000, -922.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group-14",
				transform: "translate(756.000000, 922.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "clock_gr",
					transform: "translate(80.000000, 0.000000)",
					children: [
						/* @__PURE__ */ _jsx("circle", {
							id: "Oval",
							fill: "#ECEDF4",
							cx: 26.5,
							cy: 26.5,
							r: 16.5
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M26.5,0 C41.1355459,0 53,11.8644541 53,26.5 C53,41.1355459 41.1355459,53 26.5,53 C11.8644541,53 0,41.1355459 0,26.5 C0,11.8644541 11.8644541,0 26.5,0 Z M26.5,5 C14.6258779,5 5,14.6258779 5,26.5 C5,38.3741221 14.6258779,48 26.5,48 C38.3741221,48 48,38.3741221 48,26.5 C48,14.6258779 38.3741221,5 26.5,5 Z",
							id: "Oval-Copy-30",
							fill: "#DADBEA",
							fillRule: "nonzero"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle",
							fill: "#DADBEA",
							style: { mixBlendMode: "multiply" },
							x: 24,
							y: 0,
							width: 5,
							height: 30,
							rx: 2
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle",
							fill: "#DADBEA",
							style: { mixBlendMode: "multiply" },
							x: 24,
							y: 25,
							width: 19,
							height: 5,
							rx: 2
						})
					]
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgClockGr);
export default ForwardRef;
